/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Ai_Team_BillingInputs */



/**
* | output |
* | --- |
* | "€5/user credit pool" |
*
* @param {Compare_Ai_Team_BillingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_ai_team_billing = /** @type {((inputs?: Compare_Ai_Team_BillingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Ai_Team_BillingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("€5/Nutzer Credit-Pool")
	return /** @type {LocalizedString} */ ("€5/user credit pool")
});